<template>
<div id="ag-grid-demo">
        <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3 mt-10">
            <div class="filters-container flex flex-wrap items-center justify-start pb-3">
                <v-select
                    style="min-width: 200px"
                    class="mt-3 mr-3"
                    name="company"
                    label="name"
                    placeholder="Actions"
                />
                <button
                    class="mt-3 ml-3 add_new_button"
                >+ Add New</button>
            </div>
            <div class="flex">
              <div class="col-4">
                <per-page
                  :currentPerPage="per_page"
                  :pageStart="pageStart"
                  :pageEnd="pageEnd"
                  :total="totalPages"
                  @change-per-page="ChangePerPage($event)"
                />
              </div>
              <div class="col-8">
                <div class="form-group has-search" v-on:click="onQuickFilterChanged()">
                  <span class="fa fa-search form-control-feedback"></span>
                  <input
                    type="search"
                    v-on:input="onQuickFilterChanged()"
                    id="quickFilter"
                    class="filter_input form-control"
                  >
                </div>
              </div>
                <!-- <vs-input
                        icon="iconsearch"
                        icon-no-border
                        icon-pack="feather"
                        class="input-rounded-full ml-5"
                        id="filter-text-box"
                        @oninput="onFilterTextBoxChanged()"
                    /> -->
            </div>
        </div>
        <div class="table_container">

            <ag-grid-vue
                class="w-100 my-4 ag-grid-table ag-theme-material"
                id="myGrid"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :suppressRowClickSelection="true"
                :pagination="true"
                :suppressPaginationPanel="true"
                :rowData="rowData"
                :rowSelection="rowSelection"
                :paginationPageSize="paginationPageSize"
            ></ag-grid-vue>
            <vs-pagination
            :total="totalPages"
            class="pag"
            :max="maxPageNumbers"
            v-model="currentPage" />
        </div>
</div>
</template>
<script>
import TableMixin from '@/mixins/table.js'

// Packages
import vSelect from 'vue-select'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from '../../admin/clients/users/cell-renderer/CellRendererActions'
import CellRendererStatus from '../../admin/clients/users/cell-renderer/CellRendererStatus'
import { BProgress, BBadge } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


// Cell Renderer components
export default {
    mixins: [TableMixin],
  components: {
    AgGridVue,
    vSelect,
    CellRendererActions,
    CellRendererStatus,
    BProgress,
    BBadge
  },
data (){
      return{
       columnDefs: null,
       rowSelection: null,
       defaultColDef: null,
       rowData: null,
       maxPageNumbers:null,
       rowStyle:null,
       gridOptions: null,
       gridApi: null,
       columnApi: null,
        components: {
            CellRendererActions,
            CellRendererStatus
      }
      }
  },
  beforeMount(){
       this.rowSelection = 'multiple';
      this.gridOptions = {
            rowHeight: 80,
            rowStyle: {
        'border-bottom': '#F8F8F8 10px solid',
        'border-top': '#F8F8F8 10px solid'
    },
        };
      this.columnDefs = [
          {
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            width: 20,

          },
        {
            headerName: 'Keyword',
            field:'keyword',
            width: 200,
        },
        {
            headerName: 'Response',
            field: 'response',
            width:200
        },
       {
            headerName: 'Created On',
            field: 'progresbar',
            width: 100,
            cellRenderer: (params) => {
                    return '<div class="progress mt-6 mr-5 h-2"><div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div></div>'
                // return '<b-progress show-value><b-progress-bar value="25" :max="100" height="50px"></b-progress-bar></b-progress>'
            }
        },
        {
            headerName: 'Status',
            field: 'status',
            cellRenderer: (params) => {
                if(params.value=='Delivered'){
                    return '<span class="badge badge-pill success">'+params.value+'</span>'
                }
                else if(params.value=="On Hold"){
                    return '<span class="badge badge-pill warning">'+params.value+'</span>'
                }else{
                    return '<span class="badge badge-pill primary">'+params.value+'</span>'

                }
            }
        },
        {
            headerName: 'Action',
            field: 'action',
            cellRendererFramework: 'CellRendererActions',
            width: 100,
        }
      ];
      this.rowData = [
        {
            keyword: 'Keyword 1',
            status: 'Delivered',
            response: 'Response 1',
            progresbar: ''

        },
        {
            keyword: 'Keyword 2',
            status: 'On Hold',
            response: 'Response 2'
        },
        {
            keyword: 'Keyword 3',
            status: 'Pending',
            response: 'Response 3'
        },
      ];
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.sizeColumnsToFit()

    // fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
    //     .then((resp) => resp.json())
        // .then((data) =>  this.rowData = data);
  },
  computed:{
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage:{
         get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }

    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
  },
  methods: {
    onQuickFilterChanged() {
      this.gridApi.setQuickFilter(document.getElementById('quickFilter').value);
    },
  },
}
</script>
<style>
    .container_{
        width: 85%;
        margin:auto;
    }
    .add_new_button{
        width: 100px;
        height: 40px;
        border:1px solid #7367EC;
        color: #7367EC;
        border-radius: 5px;
        background-color: white;
    }
    .add_new_button:hover{
        background-color: #7367EC;
        color: white;
        transition: 0.5s;
    }
    .table_container{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .ag-theme-material .ag-root-wrapper {
        background-color: transparent!important;
    }
    .ag-theme-material .ag-header {
        background-color: transparent!important;
        border-bottom: none!important;
    }
    .ag-theme-material .ag-row {
        background: white;
        border-radius: 10px;
    }
    .filter_input{
        border:1px solid lightgray;
        border-radius:30px;
        margin-left: 15px;
    }
    .badge{
        color: white;
        padding: 2%;
        border-radius: 55px;
    }
    .primary{
        background-color:#7367EC ;
        color: white;
    }
    .success{
        background-color: #1EC775;
        color: white;
    }
    .warning{
        background-color: #FE9E4D;
        color: white;
    }
    .ag-header-cell-label {
        justify-content: center;
    }
    .ag-grid-table{
        justify-content: center;
    }
    .ag-row{
        text-align: center;
    }
    .filter_input{
        padding: 17px;
        padding-left: 55px;
        /*width: 300px;*/
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;
        margin-top: 20px;
    }
</style>
